import { useState } from 'react'
import { Asset } from '@api/models'
import { ReportsApi } from '@api'
import { Button, Card, toast } from '@components/common'
import { ERROR_REQUEST } from '@constants'
import { reportResponseHandler } from '@utils/reports'

interface Props {
  asset: Asset
}

const KiaVehicleReportCard = ({ asset }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleGeneratePdf = async () => {
    setIsLoading(true)
    await ReportsApi.getInstance()
      .getKiaVehicleReport({
        assetCompanyID: asset.AssetCompanyID,
        assetId: asset.AssetID,
      })
      .then(data => reportResponseHandler(data, 'pdf'))
      .catch(() => toast.error(ERROR_REQUEST))
      .finally(() => setIsLoading(false))
  }

  return (
    <Card title="Vehicle Report">
      <Button onClick={handleGeneratePdf} loading={isLoading} disabled={isLoading}>
        Generate PDF
      </Button>
    </Card>
  )
}

export default KiaVehicleReportCard
